import { useMutation } from "urql";

import { DeleteMessageTemplateDocument } from "../../../../graphql/generated.ts";

export function useDeleteMessageTemplate() {
  return useMutation(DeleteMessageTemplateDocument);
}
